export const HomeBackground = '/backgrounds/game-background.jpg';
export const DefaultBackground = '/backgrounds/default-background.png';
export const EndBackground = '/backgrounds/end-background.jpg';
export const SubscribeBackground = '/backgrounds/subscribe-background.jpg';
